<template>
        <button type="button" @click="updateChk">
            <svg v-if="isChecked" class="checkmark"><use xlink:href="#checkmark"></use></svg>
            <svg v-else class="add_grey"><use xlink:href="#add_grey"></use></svg>
        </button>
</template>
<script>
export default {

    props: {
        value: {
            required: true,
        },
        day: {
            required: true,
        },
        time: {
            required: false,
            default: null,
        }
    },

    data() {
        return {
            currentValue: this.value,
            isChecked: false,
        }
    },

    created() {
        this.setCheck()
    },

    methods: {

        setCheck() {
            this.isChecked = !!_.find(this.currentValue, item => {
                return item.day == this.day
            })
        },

        updateChk() {
            this.isChecked = !this.isChecked
            if (this.isChecked) {
                this.currentValue.push({'day': this.day, 'time': this.time})
            } else {
                let index = _.findIndex(this.currentValue, v => v.day == this.day)
                this.currentValue.splice(index, 1)
            }
            this.$emit('input', this.currentValue)
        }
    },

    watch: {
        value() {
            this.currentValue = this.value
            this.setCheck()
        },
    }
}
</script>
